import React from 'react';

import styled from 'styled-components';

const About = () => {

return(
  <Container>
    About
  </Container>
)

}
export default About;

const Container = styled.div`

`;